exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".publish{\n    font-size: 20px;\n    float: right;\n    margin-bottom: 0px;\n    margin-top: 3px;\n    margin-right: 50px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/settings/settings.component.css
// module id = ../../../../../src/app/settings/settings.component.css
// module chunks = main